import axios from 'axios';

const data = axios.create({
    baseURL: 'http://www.seel.ufc.br/inscricoes/server/' //
});
// 
export default data;